import Fetch from 'fetch';

const fixImagePath = (itemParam) => {
    const item = itemParam;
    let { image } = item;
    const { REACT_APP_CONTEXT: appContext } = process.env;
    image = image.replace(
        '$!staticResourcesContext',
        appContext === '/' ? '' : appContext,
    );
    item.image = image;
};

export default {
    getFooterData() {
        return Fetch.get('/site-olb/v1/footer').then((data) => {
            const { footerLinks = [] } = data;
            footerLinks.forEach((item) => {
                fixImagePath(item);
            });

            return data;
        });
    },
};
